import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '@/firebase';
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { activatePlugin, deactivatePlugin } from './services/plugins-api';

export const usePluginsStore = defineStore('linker-plugins', {
	state: () => ({
		plugins: {},
		pendingToggles: {},
		hydrated: false,
		unsubscribe: null,
	}),

	actions: {
		subscribe() {
			if (this.unsubscribe) return true;
			const tenantId = useAuthStore().tenantId;
			if (!tenantId) return false;

			const ref = collection(db, `tenants/${tenantId}/plugins`);
			this.unsubscribe = onSnapshot(ref, (snapshot) => {
				const next = {};
				snapshot.forEach((doc) => {
					next[doc.id] = doc.data();
				});
				this.plugins = next;
				this.hydrated = true;
			});
			return true;
		},

		isPluginReady(pluginId) {
			const p = this.plugins[pluginId];
			return !!p?.enabled && p?.bootstrap?.status === 'ready';
		},

		async toggle(pluginId, enable) {
			this.pendingToggles[pluginId] = true;
			try {
				return await (enable ? activatePlugin : deactivatePlugin)(pluginId);
			} finally {
				delete this.pendingToggles[pluginId];
			}
		},
	},
});
